import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteUser(
  uuid: string,
  disableInIdp?: boolean
): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/iam/user/${uuid}`, {
    params: {
      disableInIdp: disableInIdp ?? false,
    },
  })
}
